import Cookies from 'js-cookie';

const getLanguage = function getLanguage(locales) {
  const defaultLanguage = 'EN';
  const navLanguage = locales.filter(locale => window.navigator.language.substr(0, 2)
    .toLowerCase()
    .includes(locale.toLowerCase()))[0];
  if (!Cookies.get('language')) {
    return navLanguage && navLanguage !== '' ? navLanguage : defaultLanguage;
  }
  const cookieLanguage = Cookies.get('language');
  return cookieLanguage && cookieLanguage !== '' ? cookieLanguage : navLanguage;
};

export default getLanguage;

// import Cookies from 'js-cookie';
//
// const getLanguage = function getLanguage() {
//   const defaultLanguage = 'EN';
//   const navLanguage = 'FR';
//   if (!Cookies.get('language')) {
//     return navLanguage && navLanguage !== '' ? navLanguage : defaultLanguage;
//   }
//   const cookieLanguage = Cookies.get('language');
//   return cookieLanguage && cookieLanguage !== '' ? cookieLanguage : navLanguage;
// };
//
// export default getLanguage;
